import { Customer } from '@modules/customer-store';
import { ICustomerDetailsPage } from '../types';

export const EMPTY_CUSTOMER: Customer = {
  bankAccount: {
    sortCode: '',
    accountNumber: '',
    bankName: '',
  },
  id: '',
  emailAddress: '',
  status: '',
  firstName: '',
  lastName: '',
  telephoneNumber: '',
  dateOfBirth: '',
  address: {
    address1: '',
    address2: '',
    town: '',
    county: '',
    country: '',
    postCode: '',
  },
  marketingPreferences: [],
};

export const EMPTY_CUSTOMER_DETAILS_PAGE: ICustomerDetailsPage = {
  preferences: {
    keepInTouch: undefined,
  },
  customerDetails: {
    ...EMPTY_CUSTOMER,
    dateOfBirth: undefined,
  },
};
